import FingerprintJS from '@fingerprintjs/fingerprintjs';
import {
  FinteqHubProcessing,
  ProcessOperationResponse,
} from '@finteqhub/sdk-js';

import {
  PayLoadValue,
  PaymentFormField,
  PreprocessorConfiguration,
  SdkProcessorPreprocessorParameters,
} from '@cashier/cashier-model';

import { DataConverter } from './dataConverter';

const setupFingerprint = async () => {
  const fp = await FingerprintJS.load();

  return fp.get();
};

const setupInstance = (
  parameters: SdkProcessorPreprocessorParameters,
  visitorId: string,
  sessionId: string,
) => {
  return new FinteqHubProcessing(
    parameters.preprocessorUrl,
    visitorId,
    parameters.pspMerchantId,
    sessionId,
  );
};

export const SdkProcessorService = {
  async processPayment(
    paymentAttributes: PaymentFormField[],
    formPayload: { [name: string]: { value: PayLoadValue } },
    preprocessor: PreprocessorConfiguration,
  ): Promise<ProcessOperationResponse> {
    const { visitorId } = await setupFingerprint();

    let sessionId: string | undefined;
    let externalAccountId: string | undefined;

    for (const attr of paymentAttributes) {
      if (attr.name === 'sessionId' && typeof attr.value === 'string') {
        sessionId = attr.value;
      }

      if (attr.name === 'externalAccountId' && typeof attr.value === 'string') {
        externalAccountId = attr.value;
      }
    }

    if (!sessionId) {
      throw new Error('Session ID is required');
    }

    const processing = setupInstance(
      preprocessor.parameters as SdkProcessorPreprocessorParameters,
      visitorId,
      sessionId,
    );

    const sdkProcessorSession = await processing.getSession();

    const payload = DataConverter.toFormPayload(
      sdkProcessorSession,
      formPayload,
      externalAccountId,
    );

    // @ts-ignore
    return await processing.submitForm(payload);
  },
};
